module.exports = __webpack_public_path__ + "img/appearance.58623aa0.svg";